// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__EciCu","authenticated":"Avatar_authenticated__IMLtx","firstPlayer":"Avatar_firstPlayer__R3LuW"};